import removeMd from 'remove-markdown';

import type { AssistantThreadMessage } from '../../../../../../../../../shared/entities/AssistantThreadMessage';

export function getTextFromContentSegment(message: AssistantThreadMessage) {
  const contentMessage = message.content.filter(
    segment => segment.type === 'text',
  );

  const onlyText = contentMessage
    .map(segment => segment.content)
    .join('')
    .replace(/ +\./g, '.');

  return {
    markdown: onlyText,
    plainText: removeMd(onlyText),
  };
}
